import { Injectable } from '@angular/core';
import { SurfaceTier } from '@app/core/models/types/surface-tier.type';
import { BigCommerceModeStateService } from '@app/core/services/bigcommerce-mode-state.service';
import { BootstrapThemeProp } from '@app/core/services/bootstrap-theme.service';
import { faCircleSmall, faGlobe, faSparkles, faStar, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

export type SurfaceTierThemeType = {
    tier: SurfaceTier;
    displayName: string;
    icon?: IconDefinition;
    image?: string;
    bgLightTheme: BootstrapThemeProp;
    fdxBtnTheme: BootstrapThemeProp;
};

export const SURFACE_TIER_THEMES: Record<SurfaceTier, SurfaceTierThemeType> = {
    'basic': {
        tier: 'basic',
        displayName: 'Surface Basic',
        icon: faCircleSmall,
        bgLightTheme: 'secondary',
        fdxBtnTheme: 'secondary'
    },
    'retail': {
        tier: 'retail',
        displayName: 'Surface Retail',
        icon: faStar,
        bgLightTheme: 'primary',
        fdxBtnTheme: 'discovery'
    },
    'premium': {
        tier: 'premium',
        displayName: 'Premium Retail',
        image: '/dist/app/assets/icons/premium_retail.svg',
        bgLightTheme: 'primary',
        fdxBtnTheme: 'discovery'
    },
    'agentic': {
        tier: 'agentic',
        displayName: 'Agentic',
        icon: faSparkles,
        bgLightTheme: 'info',
        fdxBtnTheme: 'primary'
    },
    'full-service': {
        tier: 'full-service',
        displayName: 'Full Service',
        icon: faGlobe,
        bgLightTheme: 'discovery',
        fdxBtnTheme: 'discovery'
    }
};

@Injectable({
    providedIn: 'root'
})
export class SurfaceTierThemeService {

    constructor(
        private readonly bigCommerceMode: BigCommerceModeStateService
    ) {}

    getTierThemeType(tierName: SurfaceTier): SurfaceTierThemeType {
        return SURFACE_TIER_THEMES[tierName] ?? null;
    }

    /**
     * Gets the user's current tier theme type.
     * @returns the user's current tier theme type
     */
    getCurrentTierThemeType(): SurfaceTierThemeType {
        const currentTier: SurfaceTier = this.bigCommerceMode.getCurrentTier();
        return this.getTierThemeType(currentTier);
    }

    /**
     * Gets the user's next tier theme type.
     * @returns the user's next tier theme type
     */
    getNextTierThemeType(): SurfaceTierThemeType {
        const nextTier: SurfaceTier = this.bigCommerceMode.getNextTier();
        return this.getTierThemeType(nextTier);
    }
}
